// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__17SAW","text":"About_text__149sq"};